import type { Rect } from '~/types/pipeline';

export type ResizableEdge = 'top' | 'bottom' | 'left' | 'right';

export const MIN_PIN_BBOX_SIZE = 4;

export function resizeBBoxToEdge(bbox: Rect, side: ResizableEdge, edge: number): Rect {
  const rounded = Math.round(edge);
  if (side === 'left') {
    const right = bbox.x + bbox.w;
    const x = Math.min(rounded, right - MIN_PIN_BBOX_SIZE);
    return { x, y: bbox.y, w: right - x, h: bbox.h };
  }
  if (side === 'right') {
    const right = Math.max(rounded, bbox.x + MIN_PIN_BBOX_SIZE);
    return { x: bbox.x, y: bbox.y, w: right - bbox.x, h: bbox.h };
  }
  if (side === 'top') {
    const bottom = bbox.y + bbox.h;
    const y = Math.min(rounded, bottom - MIN_PIN_BBOX_SIZE);
    return { x: bbox.x, y, w: bbox.w, h: bottom - y };
  }
  const bottom = Math.max(rounded, bbox.y + MIN_PIN_BBOX_SIZE);
  return { x: bbox.x, y: bbox.y, w: bbox.w, h: bottom - bbox.y };
}

export function resizeBBoxByDelta(bbox: Rect, side: ResizableEdge, delta: number): Rect {
  if (side === 'left') return resizeBBoxToEdge(bbox, side, bbox.x + delta);
  if (side === 'right') return resizeBBoxToEdge(bbox, side, bbox.x + bbox.w + delta);
  if (side === 'top') return resizeBBoxToEdge(bbox, side, bbox.y + delta);
  return resizeBBoxToEdge(bbox, side, bbox.y + bbox.h + delta);
}
